import * as lib from '~/dependencies';
import * as config from '~/config/config';
import { electron } from '~/helpers';
import * as locales from './locales';
import customLngDetector from './customLngDetector';

const isProduction = process.env.NODE_ENV === 'production';
const isDevWebUrl =
  typeof window !== 'undefined' &&
  (window.location?.origin === config.WEB_URL_DEV ||
    window.location?.origin === 'https://localhost:3001');

// Make the list of locales dynamically.
const i18nAvailableLng = [];
const localeArr = Object.keys(locales).map(k => {
  const key = locales[k]?.lang;
  const newKey = key.replace('_', '-');
  i18nAvailableLng.push(newKey);

  return {
    [key]: {
      translation: locales[k]?.translation,
    },
  };
});
const localeList = Object.assign({}, ...localeArr);

// Persist the list of available languages
localStorage.setItem('i18nAvailableLng', JSON.stringify(i18nAvailableLng));

// Custom language detector
const languageDetector = new lib.LanguageDetector();
languageDetector.addDetector(customLngDetector);

lib.i18n
  // i18n backend
  .use(lib.ChainedBackend)
  // Detect user language
  .use(languageDetector)
  // Pass the i18n instance to react-i18next.
  .use(lib.initReactI18next)
  // Init i18next
  .init(
    {
      debug: !isProduction,
      fallbackLng: 'en',
      interpolation: {
        escapeValue: false,
      },
      preload: ['en'],
      ns: ['translation'],
      defaultNS: 'translation',
      backend: {
        backends: isDevWebUrl
          ? [lib.i18nResourcesToBackend(localeList)]
          : [lib.i18nHttpBackend, lib.i18nResourcesToBackend(localeList)],
        backendOptions: isDevWebUrl
          ? []
          : [
              {
                loadPath: `${
                  isProduction
                    ? config.S3_BASE_URL_PROD
                    : config.S3_BASE_URL_DEV
                }/locales/web/{{lng}}/{{ns}}.json`,
              },
            ],
      },
      saveMissing: false,
      detection: {
        order: ['customLngDetector', 'navigator'],
      },
    },
    () => {
      const lang = localStorage.getItem('i18nextLng');
      electron.languageChanged(lang);
    }
  );

lib.i18n.on('languageChanged', lng => {
  electron.languageChanged(lng);
});

export default lib.i18n;
